import { PERMISSIONS_GENERAL, PERMISSIONS_SUBSCRIBED_PLAN } from 'constants/permissions';

import * as ICONS from 'constants/icons';
import { SCOPES } from 'constants/roles';

export default [
  {
    label: 'label.dishes',
    name: 'dishes-list',
    url: '/professional/stuff-to-eat/dishes/',
    navigationIcon: ICONS.DISH,
    scope: SCOPES.CREATOR,
    show: true,
    pages: [
      {
        label: 'label.general_information',
        navigationIcon: 'far fa-info',
        name: 'dish-main-details-view',
        type: 'section',
        url: '/professional/stuff-to-eat/dishes/{id}/details',
        scope: SCOPES.CREATOR,
        pages: [
          {
            label: 'label.main_details',
            name: 'dish-main-details-view',
            navigationIcon: '',
            url: '/professional/stuff-to-eat/dishes/{id}/details/main-details',
            scope: SCOPES.CREATOR,
          },
          {
            label: 'label.categorisation',
            name: 'dish-categorisation',
            navigationIcon: '',
            url: '/professional/stuff-to-eat/dishes/{id}/details/categorisation',
            scope: SCOPES.CREATOR,
          },
          {
            label: 'label.nutrition_information',
            navigationIcon: 'far fa-hexagon',
            name: 'dish-nutrition-information',
            url: '/professional/stuff-to-eat/dishes/{id}/details/nutrition-information',
            pages: [],
            scope: SCOPES.CREATOR,
          },
          {
            label: 'label.allergens',
            navigationIcon: 'far fa-hexagon',
            name: 'dish-allergens',
            url: '/professional/stuff-to-eat/dishes/{id}/details/allergens',
            scope: SCOPES.CREATOR,
            requiredSubscribedFeature: PERMISSIONS_SUBSCRIBED_PLAN.FOOD_ALLERGENS,
          },
        ],
      },
      {
        label: 'label.related_content',
        navigationIcon: 'far fa-code-branch',
        name: 'dish-related-content',
        type: 'section',
        url: '/professional/stuff-to-eat/dishes/{id}/related-content',
        scope: SCOPES.CREATOR,
        pages: [
          {
            label: 'label.serving_sizes',
            navigationIcon: 'far fa-arrow-from-bottom',
            name: 'dish-serving-sizes',
            url: '/professional/stuff-to-eat/dishes/{id}/related-content/serving-sizes',
            pages: [],
            scope: SCOPES.CREATOR,
          },
          {
            label: 'label.ingredients',
            navigationIcon: '',
            name: 'dish-ingredients',
            url: '/professional/stuff-to-eat/dishes/{id}/related-content/ingredients',
            pages: [],
            scope: SCOPES.CREATOR,
          },
          {
            label: 'label.instructions',
            navigationIcon: '',
            name: 'dish-instructions',
            url: '/professional/stuff-to-eat/dishes/{id}/related-content/instructions',
            pages: [],
            scope: SCOPES.CREATOR,
          },
          {
            label: 'label.images',
            navigationIcon: '',
            name: 'dish-images',
            url: '/professional/stuff-to-eat/dishes/{id}/related-content/images',
            pages: [],
            scope: SCOPES.CREATOR,
          },
          {
            label: 'label.exchanges',
            navigationIcon: '',
            name: 'dish-exchanges',
            url: '/professional/stuff-to-eat/dishes/{id}/related-content/exchanges',
            pages: [],
            scope: SCOPES.CREATOR,
          },
        ],
      },
      {
        label: 'label.settings',
        navigationIcon: 'fas fa-sliders-v',
        name: 'dish-settings',
        type: 'section',
        url: '/professional/stuff-to-eat/dishes/{id}/settings',
        scope: SCOPES.CREATOR,
        pages: [
          {
            label: 'label.status',
            name: 'dish-status',
            navigationIcon: '',
            url: '/professional/stuff-to-eat/dishes/{id}/settings/status',
            scope: SCOPES.CREATOR,
          },
          {
            label: 'label.delete',
            class: 'is-delete',
            name: 'dish-delete',
            navigationIcon: '',
            requiredPermissionsGeneral: PERMISSIONS_GENERAL.DELETE,
            url: '/professional/stuff-to-eat/dishes/{id}/settings/delete',
            scope: SCOPES.CREATOR,
          },
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/data/navigations/stuff-to-eat/navigation-stuff-to-eat-dish.js